export default __webpack_public_path__ + "static/media/tamilnadu.16c74be8.jpg";